import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import VerifyAccountBanner from "../../../components/common/verifyAccountBanner/VerifyAccountBanner";

import { Mixpanel } from "../../../actions/mixpanel.actions";

import styles from "./Footer.scss";
import logo from "../../../assets/images/logo-footer.svg";
import linkedIn from "../../../assets/images/linked-in.svg";
import facebook from "../../../assets/images/facebook.svg";
import instagram from "../../../assets/images/instagram.svg";
import twitter from "../../../assets/images/twitter.svg";

const MixpanelFooter = {
  "#footer-logo": "Footer - TSS Logo",
  "#footer-tos": "Footer - Terms + Conditions",
  "#footer-privacy_policy": "Footer - Privacy Policy",
  "#footer-blog": "Footer - Blog",
  "#footer-pricing": "Footer - Pricing",
  "#footer-faq": "Footer - FAQ",
  "#footer-contact": "Footer - Contact Support",
  "#footer-sm-twitter": "Footer - Social Media - Twitter",
  "#footer-sm-linkedin": "Footer - Social Media - LinkedIn",
  "#footer-sm-facebook": "Footer - Social Media - Facebook",
  "#footer-sm-instagram": "Footer - Social Media - Instagram"
};

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: this.props.location.pathname
    };
  }

  componentDidMount() {
    Mixpanel.track_links_obj(MixpanelFooter);
  }

  logoDirection(userRole) {
    let link = "/";

    switch (userRole) {
      case "admin":
        link = "/admin/dashboard";
        break;

      case "member":
        link = "/member/projects/matches";
        break;

      case "employer":
        link = "/company/projects";
        break;

      case null:
        link = "https://www.thesecondshift.com/";
        break;
    }

    return link;
  }

  renderLogo() {
    const userRole = localStorage.getItem("role");
    if (userRole) {
      return (
        <Link to={this.logoDirection(userRole)}>
          <img
            id="footer-logo"
            src={logo}
            alt="The Second Shift"
            className={styles.logo}
          />
        </Link>
      );
    } else {
      return (
        <a href={this.logoDirection(userRole)}>
          <img
            id="footer-logo"
            src={logo}
            alt="The Second Shift"
            className={styles.logo}
          />
        </a>
      );
    }
  }

  render() {
    const hideInUrls = [
      "/member/sign-up-marketing",
      "/member/sign-up-marketing-2"
    ];

    const hide = hideInUrls.includes(this.props.location.pathname);

    return (
      <footer id="footer" className={styles.footer}>
        <VerifyAccountBanner />
        <div className={styles.footerContent}>
          {this.renderLogo()}
          <div className={styles.policies}>
            <div>© {new Date().getFullYear()} The Second Shift</div>

            <div className={styles.policiesLinks}>
              <a
                id="footer-tos"
                target="_blank"
                href="https://www.thesecondshift.com/tos"
              >
                Terms + Conditions
              </a>
              <a
                id="footer-privacy_policy"
                target="_blank"
                href="https://www.thesecondshift.com/privacy"
              >
                Privacy Policy
              </a>
              {!hide && (
                <div>
                  <a
                    id="footer-blog"
                    target="_blank"
                    href="https://blog.thesecondshift.com"
                  >
                    Blog
                  </a>
                  <a
                    id="footer-pricing"
                    target="_blank"
                    href="https://www.thesecondshift.com/fees"
                  >
                    Pricing
                  </a>
                  <a
                    id="footer-faq"
                    target="_blank"
                    href="https://thesecondshift.freshdesk.com/support/home"
                  >
                    FAQ
                  </a>
                  <a
                    id="footer-contact"
                    target="_blank"
                    href="https://thesecondshift.com/contact-us"
                  >
                    Contact Support
                  </a>
                </div>
              )}
            </div>
          </div>
          {!hide && (
            <nav className={styles.navigation}>
              <a
                id="footer-sm-twitter"
                target="_blank"
                href="https://twitter.com/thesecond_shift/"
              >
                <img src={twitter} alt="Twitter" />
              </a>
              <a
                id="footer-sm-instagram"
                target="_blank"
                href="https://www.instagram.com/thesecond_shift/"
              >
                <img src={instagram} alt="Instagram" />
              </a>
              <a
                id="footer-sm-facebook"
                target="_blank"
                href="https://www.facebook.com/The-Second-Shift-346930705470892/"
              >
                <img src={facebook} alt="Facebook" />
              </a>
              <a
                id="footer-sm-linkedin"
                target="_blank"
                href="https://www.linkedin.com/company/the-second-shift/"
              >
                <img src={linkedIn} alt="LinkedIn" />
              </a>
            </nav>
          )}
        </div>
      </footer>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = () => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Footer)
);



// WEBPACK FOOTER //
// ./src/routes/common/footer/Footer.js